import { Card, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Person from "../../images/Person.png";
const CustomLosCard = (props) => {
  return (
    <Card
      sx={{ borderRadius: "12px", padding: "8px" }}
      className="listCardsLos"
      onClick={props.onClick}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <Box>
            <img
              src={Person}
              className="listIcons"
              sx={{ borderRadius: "40%", backgroundColor: "#E0F2F7" }}
            />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 700 }}>
              {props.applicantName} , {props.locality}
            </Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {props.applicationNum}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>Date of Sanctioned:</Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "white",
              backgroundColor: "blue",
              padding: "6px",
              borderRadius: "12px",
            }}
          >
            {props.sanctionedDate}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>
            Sanctioned Amount (₹):
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#1D6590",
            }}
          >
            {props.sanctionAmt.toLocaleString()}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>Preferred Language:</Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#1D6590",
            }}
          >
            English
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700 }}>File Status:</Typography>
          <Typography
            sx={{
              fontWeight: 600,
              color: "blue",
            }}
          >
            {props.status}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};
export default CustomLosCard;
